import React, { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';
import { useRouteModel } from './routeHooks';
import { PublicRouteState } from './publicRouteState';

import { TRACE } from '../core/debug/debugMacros';

type Props = {
  children: ReactNode;
};

export const PublicRoute = observer((props: Props) => {
  const { children } = props;

  const model = useRouteModel((kernel) => new PublicRouteState(kernel.store));

  TRACE(model, `render()`, { props, model });

  return <>{children}</>;
});